import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { extract } from '@app/core/i18n/i18n.service';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RegisterComponent } from './register.component';

const routes: Routes = [
  { path: '', component: RegisterComponent, data: { title: extract('Register'), discriminantPathKey: 'REGISTER' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule, LocalizeRouterModule],
  providers: [],
})
export class RegisterRoutingModule {}
